import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagPF = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M3.04 13.043h43.92C42.72 5.274 34.476 0 25 0S7.28 5.272 3.04 13.043ZM25 50c9.476 0 17.72-5.273 21.96-13.044H3.04C7.28 44.727 15.524 50 25 50Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M33.696 25c0 4.802-3.894 7.609-8.696 7.609s-8.696-2.807-8.696-7.61a8.696 8.696 0 1 1 17.392 0Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M33.696 25a8.696 8.696 0 1 1-17.392 0"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M19.565 22.826h2.174v4.347h-2.174v-4.347ZM28.26 22.826h2.175v4.347H28.26v-4.347ZM23.913 19.565h2.174v7.609h-2.174v-7.61Z"
}));
FlagPF.displayName = 'FlagPF';
export default withFlagWrapper(FlagPF);
//# sourceMappingURL=index.js.map